import ImageTools from './../../plugins/ImageTools'

export const imageOrientation = {
  methods: {
    /**
     * Create new image
     * Create canvas based on image
     * Rotate canvas to match EXIF 1
     *
     * @param srcBase64 - Base 64 image from the original image
     * @param srcOrientation - Current orientation of the image
     * @param callback
     */
    resetOrientation(srcBase64, srcOrientation, callback) {
      var img = new Image();

      img.onload = () => {
        var width = img.width,
          height = img.height,
          canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d');

        // set proper canvas dimensions before transform & export
        if (4 < srcOrientation && srcOrientation < 9) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }

        // transform context before drawing image
        switch (srcOrientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0);
            break;
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height);
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          // case 6:
          //   ctx.transform(0, 1, -1, 0, height, 0);
          //   break;
          case 7:
            ctx.transform(0, -1, -1, 0, height, width);
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width);
            break;
          default:
            break;
        }

        // draw image
        ctx.drawImage(img, 0, 0);

        // export base64
        callback(canvas.toDataURL());
      };

      img.src = srcBase64;
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      var byteString = atob(dataURI.split(',')[1]);

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob
      var bb = new Blob([ab], {type: "image/jpeg"});
      ImageTools.resize(bb, {width: 1000, height: 1000}, ((blob, didItResize) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = (() => {
          var base64data = reader.result;

          ImageTools.resize(bb, {width: 300, height: 300}, ((blob, didItResize) => {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = (() => {
              var base64data = reader.result;
            });
          }));
        });
      }));
      return bb;
    }
  }
}